import * as yup from 'yup';

export const schema = yup.object({
  des_nome: yup.string().required(),
  des_app_base_url: yup.string().required(),
  des_api_base_url: yup.string().required(),
});
